<template>
  <div class="row">
    <div class="col-9 pt-1" :class="{ 'pt-1': setPadding }">
      <label :for="'messageTemplate_' + identifier" class="pb-1"
        >{{ label }}
        <font-awesome-icon
          v-if="!isBroadcast"
          :icon="['fa', 'info-circle']"
          :id="dataId"
        />
        <span class="required">*</span>
      </label>
      <br />
      <small v-if="isBroadcast && isRemarkShown" class="message-remark">
        Note: Put name of parameterized value in {{ nullParam }} for example if
        you have the column named "first name" in the imported file, put
        {{ firstNameParam }}
        in the message template so that it is replaced by the parameterized
        values in the imported file
      </small>
      <CrmTriggerToolTip
        v-if="triggerType === 'NARS_TOUCH_1' && hasTop40"
        :data_target="dataId"
        :exclude-customer-section="excludeCustomerSection"
      >
        <template #extra-message-field>
          {{ top40ProductMessageParam }} - message from the top 40 product file
          that was imported to the system in the column named "Message"
        </template>
      </CrmTriggerToolTip>
      <CrmTriggerToolTip
        v-else-if="triggerType === 'Shiseido REPLENISHMENT'"
        :data_target="dataId"
        :exclude-customer-section="excludeCustomerSection"
      >
        <template #extra-message-field>
          {{ productFullDescParam }} - Category name of the focused Shiseido’s
          products
        </template>
      </CrmTriggerToolTip>
      <CrmTriggerToolTip
        v-else-if="
          triggerType ===
            'CPB WELCOME (NO PURCHASE) & THANK YOU (NEW) WITH PURCHASE' ||
          triggerType === 'CPB REPLENISHMENT & TOUCH I & TOUCH II'
        "
        :data_target="dataId"
        :exclude-customer-section="excludeCustomerSection"
      >
        <template #extra-message-field>
          {{ productFullDescParam }} - CPB product description
        </template>
      </CrmTriggerToolTip>
      <CrmTriggerToolTip
        v-else-if="triggerType && !isBroadcast"
        :data_target="dataId"
        :exclude-customer-section="excludeCustomerSection"
      />
      <textarea
        :id="'messageTemplate_' + identifier"
        :value="value"
        class="form-control"
        rows="4"
        @input="updateValue"
        :disabled="isDisabled"
        :class="{
          'input--error': isSubmit  && errorMessageTemplate,
        }"
      ></textarea>
      <div v-if="isSubmit && errorMessageTemplate" class="text-error">
        {{ errorMessageTemplate.message }}
      </div>
    </div>
  </div>
</template>

<script>
import CrmTriggerToolTip from "components/Tooltip/CrmTriggerToolTip.vue";

export default {
  name: "CommonMessageTemplate",
  components: { CrmTriggerToolTip },
  props: {
    value: {
      type: String,
      default: () => null,
    },
    triggerType: {
      type: String,
      default: () => null,
    },
    hasTop40: {
      type: Boolean,
      default: () => false,
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
    dataId: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    setPadding: {
      type: Boolean,
      default: () => false,
    },
    isBroadcast: {
      type: Boolean,
      default: () => false,
    },
    isRemarkShown: {
      type: Boolean,
      default: () => false,
    },
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
    errorMessageTemplate: {
      type: Object,
      default: () => {},
    },
    identifier: {
      type: String,
      default: () => "",
    },
    excludeCustomerSection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      top40ProductMessageParam: "{{top 40 product message}}",
      productFullDescParam: "{{product full desc}}",
      nullParam: "{{}}",
      firstNameParam: "{{first name}}",
    };
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}
.message-remark {
  color: #666;
}
</style>
